/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};
timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $("img[id|='product-featured-image']"),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $("img[id|='product-featured-image']"),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText'),
  	  $unitPriceBox = $('.unit_price_box'),
      $productUnitPrice = $('#product__unit_price'),
  	  $productUnitValue = $('#product__unit_price_value');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(window.AddTocart.CartTitle);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(window.AddTocart.soldout);
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
    
    
    // Unit Price
    if('unit_price' in variant){
      $unitPriceBox.removeClass('hidden');
      $productUnitPrice.html( Shopify.formatMoney(variant.unit_price, moneyFormat));
      $productUnitValue.html(`${variant.unit_price_measurement.reference_value} ${variant.unit_price_measurement.reference_unit}`);
    }else{
    	$unitPriceBox.addClass('hidden');
    }
    

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(window.productCompareat + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(window.productUnavailable);
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};


// Initialize Timber's JS on docready
$(timber.init);





// Section with Editor
    $(document).on('shopify:section:load', function(e){ 
      $('#' + e.target.id).find('[data-section]').sectionJs();
    }).ready(function() {
      $('[data-section]').each(function(){ $(this).sectionJs() });
    });

  $.fn.sectionJs = function(){
    var $this = this;
    if($this.data('section') == "headerscript") {
      $this.headerscript();
    }else if($this.data('section') == "ProductPage"){
      $this.productPage();
    }else if($this.data('section') == "collectionTemplate") {
    	$this.collectionTemplaetFn();
  	}else if($this.data('section') == "RelatedProudct") {
    	$this.find('.product-carousel').SlickCarouselSlider();
      	$this.CountDown2();
  	}else if($this.data('section') == "sliderone") {
    	$this.find('.home1-slider').sliderone();
  	}else if($this.data('section') == "slidertwo") {
    	$this.find('.home2-slider').slidertwo();
  	}else if($this.data('section') == "sliderthree") {
    	$this.find('.home3-slider').sliderthree();
  	}else if($this.data('section') == "sliderfour") {
    	$this.find('.home4-slider').sliderfour();
  	}else if($this.data('section') == "sliderfive") {
    	$this.find('.home5-slider').sliderfive();
  	}else if($this.data('section') == "sliderseven") {
    	$this.find('.home7-slider').sliderseven();
  	}else if($this.data('section') == "slidereight") {
    	$this.find('.home8-slider').slidereight();
  	}else if($this.data('section') == "slidereleven") {
    	$this.find('.home12-slider').slidereleven();
  	}else if($this.data('section') == "categorybannertwo") {
    	$this.find('.category-banner1-carousel').SlickCarouselSlider();
  	}else if($this.data('section') == "CountDownBanner") {
    	$this.CountDownBanner();
  	}else if($this.data('section') == "BrandLogos") {
      $this.find('.brand-carousel').SlickCarouselSlider();
    }else if($this.data('section') == "testimonial") {
      $this.find('.testimonial-carousel').SlickCarouselSlider();
    }else if($this.data('section') == "testimonial2") {
      $this.find('.testimonial-slider').SlickCarouselSlider();
    }else if($this.data('section') == "announcement-sldr") {
      $this.find('.announcement-slider').SlickCarouselSlider();
    }else if($this.data('section') == "featuredproductssmall") {
      $this.find('.product-list-slider').SlickCarouselSlider();
    }else if($this.data('section') == "InstagramSlider") {
      $this.InstagramSection();
    }else if($this.data('section') == "InstagramSliderGallery") {
      $this.find('.instagram-carousel .instagram_gallery').SlickCarouselSlider();
    }else{}   
  }
  
  
  

  /*============== Header ==================*/
  $.fn.headerscript = function() {
    /* Mega Menu */
    $('.mega_dropdown').parent('ul').addClass('sub-menu mega-menu');
    $('.drop_item').parent('ul').addClass('sub-menu');
    $('.multi_item').parent('ul').addClass('sub-menu');
  };

	/*--
        Swipper Slider Activation
    -----------------------------------*/

	// Home 1 Slider
	$.fn.sliderone = function() {
    var $home1Slider = new Swiper('.home1-slider', {
        loop: true,
        speed: 750,
        effect: 'fade',
        navigation: {
            nextEl: '.home1-slider-next',
            prevEl: '.home1-slider-prev',
        },
        autoplay: {
        	delay: 5000,
            stopOnLastSlide: true,
            disableOnInteraction: true,
        },
    });
      var mySwiper = document.querySelector('.home1-slider').swiper
      $(".home1-slider").mouseenter(function() {
        mySwiper.autoplay.stop();
        console.log('slider stopped');
      });

      $(".home1-slider").mouseleave(function() {
        mySwiper.autoplay.start();
        console.log('slider started again');
      }); 
      
      
	};


	// Home 2 Slider
	$.fn.slidertwo = function() {
      var $home2Slider = new Swiper('.home2-slider', {
          loop: true,
          speed: 750,
          effect: 'fade',
          autoplay: 4000,
          navigation: {
              nextEl: '.home2-slider-next',
              prevEl: '.home2-slider-prev',
          },
          on: {
              slideChange: function () {
                  this.$el.find('.slide-product').removeClass('active');
              },
          }
      });
      $('.home2-slider').on('click', '.slide-pointer', function (e) {
          e.preventDefault();
          $(this).siblings('.slide-product').toggleClass('active');
      })
	};


	// Home 3 Slider
	$.fn.sliderthree = function() {
    var $home3Slider = new Swiper('.home3-slider', {
        loop: true,
        speed: 750,
        effect: 'fade',
        navigation: {
            nextEl: '.home3-slider-next',
            prevEl: '.home3-slider-prev',
        },
        autoplay: {},
    });
	};


	// Home 4 Slider
	$.fn.sliderfour = function() {
    var $home4Slider = new Swiper('.home4-slider', {
        loop: true,
        loopedSlides: 2,
        speed: 750,
        spaceBetween: 200,
        pagination: {
            el: '.home4-slider-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.home4-slider-next',
            prevEl: '.home4-slider-prev',
        },
        autoplay: {},
    });
	};


	// Home 5 Slider
	$.fn.sliderfive = function() {
    var $home5Slider = new Swiper('.home5-slider', {
        loop: true,
        speed: 750,
        spaceBetween: 30,
        pagination: {
            el: '.home5-slider-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.home5-slider-next',
            prevEl: '.home5-slider-prev',
        },
        autoplay: {
        	delay: 5000,
            stopOnLastSlide: true,
            disableOnInteraction: true,
        },
    });
    };

    // Home 7 Slider
	$.fn.sliderseven = function() {
    var $home7Slider = new Swiper('.home7-slider', {
        loop: true,
        speed: 750,
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
            el: '.home7-slider-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.home7-slider-next',
            prevEl: '.home7-slider-prev',
        },
        autoplay: {
        	delay: 5000,
            stopOnLastSlide: true,
            disableOnInteraction: true,
        },
    });
    };

    // Home 8 Slider
	$.fn.slidereight = function() {
    var $home8Slider = new Swiper('.home8-slider', {
        loop: true,
        speed: 750,
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
         el: '.home8-slider-pagination',
         clickable: true, 
         renderBullet: function (index, className) {
           return '<span class="' + className + '">' + (index + 1) + "</span>";
         },
         },
        navigation: {
            nextEl: '.home8-slider-next',
            prevEl: '.home8-slider-prev',
        },
        autoplay: {
        	delay: 5000,
            stopOnLastSlide: true,
            disableOnInteraction: true,
        },
    });
    };

    // Home 12 Slider
	$.fn.slidereleven = function() {
    var $home12Slider = new Swiper('.home12-slider', {
        loop: true,
        speed: 750,
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
            el: '.home12-slider-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.home12-slider-next',
            prevEl: '.home12-slider-prev',
        },
        autoplay: {
        	delay: 5000,
            stopOnLastSlide: true,
            disableOnInteraction: true,
        },
    });
	};
    
	/*--
        CountDown
    -----------------------------------*/
    $.fn.CountDownBanner = function(){
      $('[data-countdown1]').each(function () {
        var $this = $(this),
            $finalDate = $this.data('countdown1');
        $this.countdown($finalDate, function (event) {
          $this.html(event.strftime('<div class="count"><span class="amount">%-D</span><span class="period">Days</span></div><div class="count"><span class="amount">%-H</span><span class="period">Hours</span></div><div class="count"><span class="amount">%-M</span><span class="period">Minutes</span></div><div class="count"><span class="amount">%-S</span><span class="period">Seconds</span></div>'));
        });
      });
    };
	$.fn.CountDown2 = function(){
      $('[data-countdown2]').each(function () {
        var $this = $(this),
            $finalDate = $this.data('countdown2');
        $this.countdown($finalDate, function (event) {
          $this.html(event.strftime('<div class="count"><span class="amount">%-D</span><span class="period">Days</span></div><div class="count"><span class="amount">%-H</span><span class="period">Hours</span></div><div class="count"><span class="amount">%-M</span><span class="period">Minutes</span></div><div class="count"><span class="amount">%-S</span><span class="period">Seconds</span></div>'));
        });
      });
    }; 

    // Product Page
   $.fn.productPage = function(){
    // Product Zoom
   function imgzoom(){
      $('.product-zoom').each(function () {
        var $this = $(this),
            $image = $this.data('image');
        $this.zoom({
          url: $image
        });
      });
    };

    if( $(window).width() > 767 ){
      imgzoom();
    };


  // gallery Slider
  function productGallerySldier(productMoreview) {
    var sliderBigMedia = productMoreview.find('.product_media_gallery'),
        sliderNavMedia = productMoreview.find('.product_media_nav'),
        verticalmode = sliderNavMedia.data('vertical'),
        smverticalmode = sliderNavMedia.data('vertical-sm');

    if (!sliderBigMedia.hasClass('slick-initialized') && !sliderNavMedia.hasClass('slick-initialized')) {
      sliderBigMedia.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        
        asNavFor: sliderNavMedia,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        draggable: false,
        adaptiveHeight:false,
        rows: 0,
        responsive: [
            {
               breakpoint: 575,
               settings: {
                 get arrows() {
                   if (verticalmode == true && smverticalmode == true) {
                     return arrows = true;
                   }
                 }
               }
            }
          ]
      });

      sliderNavMedia.slick({
        infinite: true,
        slidesToShow: sliderNavMedia.data('rows'),
        vertical: verticalmode,
        slidesToScroll: 1,
        asNavFor: sliderBigMedia,
        
        focusOnSelect: true,
        rows: 0,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        responsive: [
            {
               breakpoint: 992,
               settings: {
                 slidesToShow: 4,
                 slidesToScroll: 1
               }
             },
             {
               breakpoint: 768,
               settings: {
                 slidesToShow: 4,
                 slidesToScroll: 1
               }
             },
             {
               breakpoint: 575,
               settings: {
                 slidesToShow: 3,
                 slidesToScroll: 1,
                 vertical: smverticalmode,
                 get dots() {
                   if (verticalmode == true && smverticalmode == true) {
                     return dots = true;
                   }
                 },
                 get arrows() {
                   if (verticalmode == true && smverticalmode == true) {
                     return arrows = false;
                   }
                 }
             }
            }
          ]
      });
    };
    
    // Swatch image 
    var swatch = productMoreview.closest('[data-more-view-product]').siblings('.product-shop').find('.swatch'),
        swatchColor = swatch.find('.swatch-element.color'),
        inputChecked = swatchColor.find(':radio:checked');

    if(inputChecked.length) {
      var className = inputChecked.data('filter');

      if(className !== undefined) {
        sliderNavMedia.slick('slickUnfilter');
        sliderBigMedia.slick('slickUnfilter');

        if(sliderNavMedia.find(className).length && sliderBigMedia.find(className).length) {
          sliderNavMedia.slick('slickFilter', className).slick('refresh');
          sliderBigMedia.slick('slickFilter', className).slick('refresh');
        }
      };
    };
  };
  productGallerySldier($('.product__slide_wrapper'));
  
  // Single Product Page Swatch
  function changeSwatch(swatchSlt) {
    $(document).on('change', swatchSlt, function () {
      var className = $(this).data('filter');
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();

      $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');

      if (className == undefined) {
        if ($('input[data-filter]').is(':checked')) {
          var checked = $('input[data-filter]:checked').data('filter');
          className = checked;
        }
      }
      var productShop = $(swatchSlt).closest('.product-shop'),
          productImgs = productShop.prev('[data-more-view-product]');

        if(productImgs.length) {
          var sliderBigMedia = productImgs.find('.product_media_gallery'),
       		  sliderNavMedia = productImgs.find('.product_media_nav');
          sliderNavMedia.slick('slickUnfilter');
          sliderBigMedia.slick('slickUnfilter');

          if(sliderNavMedia.find(className).length && sliderBigMedia.find(className).length) {
            sliderNavMedia.slick('slickFilter', className).slick('refresh');
            sliderBigMedia.slick('slickFilter', className).slick('refresh');
          }
        }

    });
  };
  changeSwatch('#AddToCartForm .swatch :radio');  
  
  
  //===== Sticky Add To Cart
  function proStikcyAddToCart(){
    var $stikcyParent = $('.pro_sticky_atc'),
        $proVarintActive = $stikcyParent.find('.Pro_variant__active'),
        $stickyProVarItem = $stikcyParent.find('.pro_variant_swatch');

    if($stikcyParent.length) {
      $stickyProVarItem.off('click.activeVar').on('click.activeVar', function(e) {
        var $this = $(this),
            $text = $this.text(),
            $StickyVarval = $this.data('value'),
            $varnewImg = $this.data('img'),
            $newqty = $this.data('quantity');
        $stickyProVarItem.removeClass('active');
        $this.addClass('active');

        $stikcyParent.find('.sticky__pro_add_cart input[type=hidden]').val($StickyVarval);
        $proVarintActive.attr('data-value', $StickyVarval).text($text);

        var $variantSwtval = $('#AddToCartForm [data-value-sticky="'+$StickyVarval+'"]');

        $variantSwtval.each(function() {
          var $switem = $(this).data('value');

          $('[data-value="'+$switem+'"]').closest('.swatch').find('#'+$switem+'').click();
        });

        $('.sticky_pro_img img').attr({ src: $varnewImg });
        $('.sticky__qty input').attr({ totalqty: $newqty });

        return false;
      });

      // Select Option
      var $optionSelected = $('#product-selectors option:selected'),
          $StickyVarval = $optionSelected.val(),
          $prostickyActive = $stikcyParent.find('.pro_variant_swatch[data-value="'+$StickyVarval+'"]'),
          $prostickyText = $prostickyActive.html();

      $proVarintActive.html($prostickyText);
      $prostickyActive.addClass('active');

      var $datastr = $prostickyActive.data('img');
      $('.sticky_pro_img img').attr({ src: $datastr });

      $(".swatch .swatch-element").each(function(e) {
        var $varid = $(this).find('input:radio').attr('id');

        $('.swatch input.text[data-value="'+$varid+'"]').appendTo($(this));
      });
      $('.selector-wrapper').change(function() {
        var $proSelectors = $("#product-selectors").val();
        $('.pro_sticky_atc .pro_variant__options li').each(function(e) {
          var $varSinItem = $(this).find('a').data('value');
          if($varSinItem == $proSelectors){
            $(this).find('a').addClass('active')
          } else{
            $(this).find('a').removeClass('active')
          }
        });
        $("#product-selectors").change(function() {
          var $varstr = "";
          $("#product-selectors option:selected").each(function() {
            $varstr += $(this).data('imge');
          });

          $('.sticky_pro_img img').attr({ src: $varstr });
        }).trigger("change");

        if($stickyProVarItem.hasClass('active')) {
          var $StikcyVarhtml = $('.pro_sticky_atc .pro_variant_swatch.active').html();

          $('.pro_sticky_atc .sticky__pro_add_cart input[type=hidden]').val($proSelectors);
          $proVarintActive.html($StikcyVarhtml);
          $proVarintActive.attr('data-value', $proSelectors);
        };
      });

      //Proudct Scoll Sticky Class
      var offSetTop = $('.sticky__pro_button').offset().top;
      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        if (scrollTop > offSetTop) {
          $('body').addClass('atc_sticky_scoll');
        }
        else {
          $('body').removeClass('atc_sticky_scoll');
        }
      });
    };
    
    // Sticky quanity Count
    $('.quantity_inner').find('.dec_btn, .inc_btn').click(function(e) {
      var $qty_field = $(this).parent().find('input'),
          $qtCount = parseInt($qty_field.val(), 10) + parseInt(e.currentTarget.className === 'inc_btn' ? 1 : -1, 10);
      $qty_field.val($qtCount).change();
    });
    $('.quantity_inner').find("input").change(function() {
      var $this = $(this),
          $min = 1,
          $value = parseInt($this.val(), 10),
          $max = parseInt($this.attr('totalqty'), 10);
      $value = Math.min($value, $max);
      $value = Math.max($value, $min);
      $this.val($value);
    }).on("keypress", function( e ) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    });
  } 
  proStikcyAddToCart();
  
  
  
  /*------  magnific popup -----*/
      var $magnicficpopup = $('.popup-video');

      if($magnicficpopup.length > 0) {
        $magnicficpopup.magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        });
      };
  
  	 // Single Product Dynamic Checkout Button
      $('#buy-now-check').on('click', function(){
        $(this).parent('.dynmiac_checkout--label').parent('.dynmiac_checkout--button').toggleClass('disabled');
      });
};  
    
// Collection Template
$.fn.collectionTemplaetFn = function(){
 // Lazload Image
  
  /*----------  shop advance filter area toggle  ----------*/
  $('#advance-filter-active-btn').on('click', function(){
    $(this).toggleClass('active');
    $('#shop-advance-filter-area').slideToggle();
  });
  
  
  /*------- 
      	Sidebar offcanvas filter widget 
   ---------*/
  $('#sidebar-filter-active-btn').on('click', function(event){
    event.stopPropagation();
    $('.offcanvas__filter_wrapper').addClass('active-about-overlay');
    $('.filter-overlay-close').addClass('active').removeClass('inactive');
    $('body').addClass('active-body-search-overlay');
  });


  $('#filter__widget_close, .filter-overlay-close').on('click', function(){
    $('.offcanvas__filter_wrapper').toggleClass('active-about-overlay');
    $('.filter-overlay-close').addClass('inactive').removeClass('active');
    $('body').removeClass('active-body-search-overlay');
  });
  

};

// Slick Slider
$.fn.SlickCarouselSlider = function(){
  // Product Carousel Slider
  
  var rtlischeck = false;
  if($("body").css("direction") == "rtl") {
    rtlischeck = true;
  }

  
  
  var $this = this;
  if($this.length > 0){
    $this.slick({
      prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
      nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
    });
  };
};




	// Testimonial SLider/Carousel
    $('.testimonial-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
    });

   // Announcement Slider
    $('.announcement-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
    });


// Instgaram Section
$.fn.InstagramSection = function(){
	var activation = this.find('[data-username]'),
      activeId = activation.attr('id'),
      clientUsername = activation.attr('data-username'),
      instagramHastag = activation.attr('data-hashtag'),
      ItemsLimit = activation.attr('data-limit'),
      imageSize = activation.attr('data-size'),
      instaslider = ".instagram-carousel";
  
  $.instagramFeed({
    'tag': instagramHastag,
    'username': clientUsername,
    'container': "#"+activeId,
    'display_profile': false,
    'display_biography': false,
    'display_gallery': true,
    'styling': false,
    'items': ItemsLimit,
    'margin': 1,
    'image_size': imageSize
  });
  
  var $instagramNews = "#"+activeId+instaslider,
      $slidesToShow = activation.data('slidetoshow'),
      $slidesAutoplay = activation.data('slideautoplay'),
      $slideshowtablet = activation.data('slideshowtablet'),
      $slideshowlgmobile = activation.data('slideshowlgmobile'),
      $slideshowsmmobile = activation.data('slideshowsmmobile');
  
  $($instagramNews).on("DOMNodeInserted", function (e) {
    if(e.target.className == 'instagram_gallery') {
      $("." + e.target.className).slick({
        slidesToShow: $slidesToShow,
        slidesToScroll: 1,
        autoplay: $slidesAutoplay,
        dots: false,
        rtl: window.themeRTL,
        arrows: true,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        responsive: [
         {
           breakpoint: 1199,
           settings: {
             slidesToShow: $slidesToShow,
           }
         },
         {
           breakpoint: 991,
           settings: {
             slidesToShow: $slideshowtablet,
           }
         },
         {
           breakpoint: 767,
           settings: {
             slidesToShow: $slideshowlgmobile,
           }
         },
         {
           breakpoint: 575,
           settings: {
             slidesToShow: $slideshowsmmobile,
           }
         }

       ]
      })
    }
  });  
};



(function($) {
  "use strict";

  jQuery(document).ready(function(){


    // All jQuery activation code paste here
    
    
    
    
    // Cart Page
    $('#cart_button_agree').on('click', function(){
      $(this).parent('.proceed-to-checkout').toggleClass('disabled');
    });
    
    // Popup Check Terms & Condition
    $('#popup_ageree_term_cond').on('click', function(){
      $(this).parent('.modal-button').toggleClass('disabled');
    });
    
    /*--
        Commons Variables
    -----------------------------------*/
    var $window = $(window),
        $body = $('body');

    
    
    $('#google_translate_element2').bind('DOMNodeInserted', function(event) {
      $('.goog-te-menu-value span:first').html('English');
      $('.goog-te-menu-frame.skiptranslate').load(function(){
        setTimeout(function(){
          $('.goog-te-menu-frame.skiptranslate').contents().find('.goog-te-menu2-item-selected .text').html('English');    
        }, 100);
      });
    });
    
    
    
    /*--
        Custom script to call Background
        Image & Color from html data attribute
    -----------------------------------*/
    $('[data-bg-image]').each(function () {
        var $this = $(this),
            $image = $this.data('bg-image');
        $this.css('background-image', 'url(' + $image + ')');
    });
    $('[data-bg-color]').each(function () {
        var $this = $(this),
            $color = $this.data('bg-color');
        $this.css('background-color', $color);
    });
    

    /*--
        Header Sticky
    -----------------------------------*/
    $window.on('scroll', function () {
        if ($window.scrollTop() > 350) {
            $('.sticky-header').addClass('is-sticky');
        } else {
            $('.sticky-header').removeClass('is-sticky');
        }
    });
    
      //grid-color-swatch
      $('.color-container li label, .color-container li .variant_img,.size-container li > span').on('click', function(){
        var variantImage = jQuery(this).parent().find('.variant_img a').attr('href');
        jQuery(this).parents('.single-product').find('.single-product__image > a.image-wrap img').attr({ src: variantImage, srcset: variantImage }); 
        return false;
      });


    /*--
        Sub Menu & Mega Menu Alignment
    -----------------------------------*/
    var subMenuMegaMenuAlignment = () => {
        var $this,
            $subMenu,
            $megaMenu,
            $siteMainMenu = $('.site-main-menu');

        $siteMainMenu.each(function () {
            $this = $(this);
            if ($this.is('.site-main-menu-left, .site-main-menu-right') && $this.closest('.section-fluid').length) {
                $megaMenu = $this.find('.mega-menu');
                $this.css("position", "relative");
                if ($this.hasClass('site-main-menu-left')) {
                    $megaMenu.css({
                        "left": "0px",
                        "right": "auto"
                    });
                } else if ($this.hasClass('site-main-menu-left')) {
                    $megaMenu.css({
                        "right": "0px",
                        "left": "auto"
                    });
                }
            }
        });
        $subMenu = $('.sub-menu');
        if ($subMenu.length) {
            $subMenu.each(function () {
                $this = $(this);
                var $elementOffsetLeft = $this.offset().left,
                    $elementWidth = $this.outerWidth(true),
                    $windowWidth = $window.outerWidth(true) - 10,
                    isElementVisible = ($elementOffsetLeft + $elementWidth < $windowWidth);
                if (!isElementVisible) {
                    if ($this.hasClass('mega-menu')) {
                        var $this = $(this),
                            $thisOffsetLeft = $this.parent().offset().left,
                            $widthDiff = $windowWidth - $elementWidth,
                            $left = $thisOffsetLeft - ($widthDiff / 2);
                        $this.attr("style", "left:" + -$left + "px !important").parent().css("position", "relative");
                    } else {
                        $this.parent().addClass('align-left');
                    }
                } else {
                    $this.removeAttr('style').parent().removeClass('align-left');
                }
            });
        }
    }

    /*--
        Off Canvas Function
    -----------------------------------*/
    (function () {
        var $offCanvasToggle = $('.offcanvas-toggle'),
            $offCanvas = $('.offcanvas'),
            $offCanvasOverlay = $('.offcanvas-overlay'),
            $mobileMenuToggle = $('.mobile-menu-toggle');
        $offCanvasToggle.on('click', function (e) {
            e.preventDefault();
            var $this = $(this),
                $target = $this.attr('href');
            $body.addClass('offcanvas-open');
            $($target).addClass('offcanvas-open');
            $offCanvasOverlay.fadeIn();
            if ($this.parent().hasClass('mobile-menu-toggle')) {
                $this.addClass('close');
            }
        });
        $('.offcanvas-close, .offcanvas-overlay').on('click', function (e) {
            e.preventDefault();
            $body.removeClass('offcanvas-open');
            $offCanvas.removeClass('offcanvas-open');
            $offCanvasOverlay.fadeOut();
            $mobileMenuToggle.find('a').removeClass('close');
        });
    })();

    /*--
        Off Canvas Menu
    -----------------------------------*/
    function mobileOffCanvasMenu() {
        var $offCanvasNav = $('.offcanvas-menu, .overlay-menu'),
            $offCanvasNavSubMenu = $offCanvasNav.find('.sub-menu');

        /*Add Toggle Button With Off Canvas Sub Menu*/
        $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"></span>');

        /*Category Sub Menu Toggle*/
        $offCanvasNav.on('click', 'li a, .menu-expand', function (e) {
            var $this = $(this);
            if ($this.attr('href') === '#' || $this.hasClass('menu-expand')) {
                e.preventDefault();
                if ($this.siblings('ul:visible').length) {
                    $this.parent('li').removeClass('active');
                    $this.siblings('ul').slideUp();
                    $this.parent('li').find('li').removeClass('active');
                    $this.parent('li').find('ul:visible').slideUp();
                } else {
                    $this.parent('li').addClass('active');
                    $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
                    $this.closest('li').siblings('li').find('ul:visible').slideUp();
                    $this.siblings('ul').slideDown();
                }
            }
        });
    }
    mobileOffCanvasMenu();

    /*--
        Header Category
    -----------------------------------*/
    $('.header-categories').on('click', '.category-toggle', function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass('active')) {
            $this.removeClass('active').siblings('.header-category-list').slideUp();
        } else {
            $this.addClass('active').siblings('.header-category-list').slideDown();
        }
    })
    
    // Check Terms & Condition
    $('#ageree_term_cond').on('click', function(){
      $(this).parent('.cart-box-product').toggleClass('disabled');
    });

    /*--
        Shop Toolbar
    -----------------------------------*/

    // Filter Toggle
    $('.product-filter-toggle').on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
            $target = $this.attr('href');
        $this.toggleClass('active');
        $($target).slideToggle();
        $('.customScroll').perfectScrollbar('update');
    });

    // Column Toggle
    $('.product-column-toggle').on('click', '.toggle', function (e) {
        e.preventDefault();
        var $this = $(this),
            $column = $this.data('column'),
            $prevColumn = $this.siblings('.active').data('column');
        $this.toggleClass('active').siblings().removeClass('active');
        $('.products').removeClass('row-cols-xl-' + $prevColumn).addClass('row-cols-xl-' + $column);
        $.fn.matchHeight._update();
        $('.isotope-grid').isotope('layout');
    });

    /*--
        Custom Scrollbar (Perfect Scrollbar)
    -----------------------------------*/
    $('.customScroll').perfectScrollbar({
        suppressScrollX: !0
    });

    /*--
        Select2
    -----------------------------------*/

    // Basic
    $('.select2-basic').select2();
    // No Search Field
    $('.select2-noSearch').select2({
        minimumResultsForSearch: Infinity
    });

    // Custom Scrollbar For Select2 Result
    $('.select2-basic, .select2-noSearch').on('select2:open', function () {
        $('.select2-results__options').each(function () {
            var ps = new PerfectScrollbar($(this)[0], {
                suppressScrollX: true
            });
        });
    });
    


    /*--
        Nice Select
    -----------------------------------*/
    $('.nice-select').niceSelect();

    /*--
        Match Height
    -----------------------------------*/
    $('.isotope-grid .product').matchHeight();


    /*--
        Add To Wishlist
    -----------------------------------*/
    (function () {
        if (typeof mojs == 'undefined') {
            return;
        }
        var burst = new mojs.Burst({
            left: 0,
            top: 0,
            radius: {
                4: 32
            },
            angle: 45,
            count: 14,
            children: {
                radius: 2.5,
                fill: ['#F8796C'],
                scale: {
                    1: 0,
                    easing: 'quad.in'
                },
                pathScale: [.8, null],
                degreeShift: [13, null],
                duration: [500, 700],
                easing: 'quint.out'
            }
        });
        $('.add-to-wishlist').on('click', function (e) {
            var $this = $(this),
                offset = $this.offset(),
                width = $this.width(),
                height = $this.height(),
                coords = {
                    x: offset.left + width / 2,
                    y: offset.top + height / 2
                };
            if (!$this.hasClass('wishlist-added')) {
                e.preventDefault();
                $this.addClass('wishlist-added').find('i').removeClass('far').addClass('fas');
                burst.tune(coords).replay();
            }
        });
    })();

    /*--
        Parallax
    -----------------------------------*/
    $.Scrollax();

    

    /*--
        Slick Slider Activation
    -----------------------------------*/



    // Product List Slider
    $('.product-list-slider').slick({
        rows: 3,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
    });

    

    // Blog Carousel
    $('.blog-carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // Brand Carousel
    $('.brand-carousel').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 575,
            settings: {
                slidesToShow: 1
            }
        }]
    });

    
    

    



    /*--
        Isotpe
    -----------------------------------*/
    var $isotopeGrid = $('.isotope-grid');
    var $isotopeFilter = $('.isotope-filter');
    $isotopeGrid.imagesLoaded(function () {
        $isotopeGrid.isotope({
            itemSelector: '.grid-item',
            masonry: {
                columnWidth: '.grid-sizer'
            }
        });
    });
    $isotopeFilter.on('click', 'button', function () {
        var $this = $(this),
            $filterValue = $this.attr('data-filter'),
            $targetIsotop = $this.parent().data('target');
        $this.addClass('active').siblings().removeClass('active');
        $($targetIsotop).isotope({
            filter: $filterValue
        });
    });

    /*--
        MailChimp
    -----------------------------------*/
    $('#mc-form').ajaxChimp({
        language: 'en',
        callback: mailChimpResponse,
        // ADD YOUR MAILCHIMP URL BELOW HERE!
        url: 'http://devitems.us11.list-manage.com/subscribe/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef'

    });

    function mailChimpResponse(resp) {
        if (resp.result === 'success') {
            $('.mailchimp-success').html('' + resp.msg).fadeIn(900);
            $('.mailchimp-error').fadeOut(400);
        } else if (resp.result === 'error') {
            $('.mailchimp-error').html('' + resp.msg).fadeIn(900);
        }
    }


    /*--
        Bootstrap
    -----------------------------------*/

    /* Accordion/Collapse */
    $('.collapse').on('show.bs.collapse', function (e) {
        $(this).closest('.card').addClass('active').siblings().removeClass('active');
    });
    $('.collapse').on('hide.bs.collapse', function (e) {
        $(this).closest('.card').removeClass('active');
    });

    /* Modal */
    $('#quickViewModal').on('shown.bs.modal', function (e) {
        $('.product-gallery-slider-quickview').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
            nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
        });
    })

    /*--
        Product Quantity
    -----------------------------------*/
    $('.qty-btn').on('click', function () {
        var $this = $(this);
        var oldValue = $this.siblings('input').val();
        if ($this.hasClass('plus')) {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 1) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }
        $this.siblings('input').val(newVal);
    });

    /*--
        Post Share
    -----------------------------------*/
    $('.post-share').on('click', ".toggle", function () {
        var $this = $(this),
            $target = $this.parent();
        $target.hasClass('active') ? $target.removeClass('active') : $target.addClass('active');
    });

    /*--
        Magnific Popup
    -----------------------------------*/
    $('.video-popup').magnificPopup({
        type: 'iframe'
    });
    
    

    /*--
        Scroll Up
    -----------------------------------*/
    $.scrollUp({
        scrollText: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up"><line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>',
    });
    


    /*--
        Sticky Sidebar
    -----------------------------------*/
    $('.sticky-sidebar').stickySidebar({
        topSpacing: 60,
        bottomSpacing: 60,
        containerSelector: '.sticky-sidebar-container',
        innerWrapperSelector: '.sticky-sidebar-inner',
        minWidth: 992
    });

    /*--
        Ajax Contact Form
    -----------------------------------*/
    $(function () {
        // Get the form.
        var form = $('#contact-form');
        // Get the messages div.
        var formMessages = $('.form-messege');
        // Set up an event listener for the contact form.
        $(form).submit(function (e) {
            // Stop the browser from submitting the form.
            e.preventDefault();
            // Serialize the form data.
            var formData = $(form).serialize();
            // Submit the form using AJAX.
            $.ajax({
                    type: 'POST',
                    url: $(form).attr('action'),
                    data: formData
                })
                .done(function (response) {
                    // Make sure that the formMessages div has the 'success' class.
                    formMessages.removeClass('error text-danger').addClass('success text-success learts-mt-10').text(response);
                    // Clear the form.
                    form.find('input:not([type="submit"]), textarea').val('');
                })
                .fail(function (data) {
                    // Make sure that the formMessages div has the 'error' class.
                    formMessages.removeClass('success text-success').addClass('error text-danger mt-3');
                    // Set the message text.
                    if (data.responseText !== '') {
                        formMessages.text(data.responseText);
                    } else {
                        formMessages.text('Oops! An error occured and your message could not be sent.');
                    }
                });
        });
    });

    /*--
        On Load Function
    -----------------------------------*/
    $window.on('load', function () {
        subMenuMegaMenuAlignment();
    });

    /*--
        Resize Function
    -----------------------------------*/
    $window.resize(function () {
        subMenuMegaMenuAlignment();
    });
    
    
     
   // Currency
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm); 

    

  });
  
})(jQuery);
